import { render, staticRenderFns } from "./MsiSpinner.vue?vue&type=template&id=2a59b365&functional=true&"
var script = {}
import style0 from "./MsiSpinner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports